import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import Bricks from "../../../img/Plane.jpg"; // Ensure the path is correct
import Tours from "./Tours";
import Balance from "./Balance";
import { useIsMobile } from "../../../Hooks/useMedia";
import { useAuth } from "../../../Context/Auth/AuthContext";
import Partners from "./Partners";

const Dashboard = () => {
   const { userState } = useAuth();
   const mobile = useIsMobile();
   return (
      <>
         <Box
            sx={{
               backgroundImage: `url(${Bricks})`,
               backgroundSize: "cover",
               backgroundPosition: { xs: "right center", sm: "center" },
               height: { xs: "60vh", sm: "80vh", md: "90%" },
               width: { xs: "94vw", sm: "92dvw" },
               mt: { xs: 8, sm: 10, md: 12 },
               mx: "auto",
               zIndex: -1,
               borderRadius: { xs: "1.5rem", sm: "2rem", md: "3rem" },
               position: "relative",
            }}
         >
            <Box
               sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  p: { xs: 3, sm: 4, md: 8, lg: 12 },
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: { xs: "flex-end", sm: "center" },
                  alignItems: { xs: "center", sm: "flex-start" },
                  pb: { xs: 4, sm: 0 },
               }}
            >
               <Typography
                  sx={{
                     color: "white",
                     fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
                     mb: { xs: 0.5, sm: 1 },
                     fontFamily: "Source Serif Pro",
                     textAlign: { xs: "center", sm: "left" },
                  }}
               >
                  Elevate Your Travel Journey
               </Typography>
               <Typography
                  variant="h1"
                  sx={{
                     color: "black",
                     fontSize: { xs: "1.5rem", sm: "2.5rem", md: "3rem" },
                     fontWeight: "bold",
                     maxWidth: "xl",
                     lineHeight: { xs: 1.2, sm: "tight" },
                     fontFamily: "Source Serif Pro",
                     textAlign: { xs: "center", sm: "left" },
                  }}
               >
                  Travel{" "}
                  <Box component="span" sx={{ fontWeight: "normal" }}>
                     with
                  </Box>{" "}
                  Care,
                  <br />
                  Explore{" "}
                  <Box component="span" sx={{ fontWeight: "normal" }}>
                     with
                  </Box>{" "}
                  Confidence!
               </Typography>

               <Button
                  component={Link}
                  to="#"
                  sx={{
                     mt: { xs: 2, sm: 3, md: 4 },
                     bgcolor: "primary.main",
                     color: "white",
                     py: { xs: 1, sm: 1.5 },
                     px: { xs: 3, sm: 4 },
                     width: { xs: "200px", sm: "250px" },
                     borderRadius: 2,
                     fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
                     fontWeight: 500,
                     "&:hover": {
                        bgcolor: "primary.dark",
                     },
                     textTransform: "none",
                     fontFamily: "Source Serif Pro",
                  }}
               >
                  Book Your Trip Now!
               </Button>
            </Box>
         </Box>
         <Box
            sx={{
               mt: "2rem",
            }}
         >
            <Typography
               sx={{
                  textAlign: "center",
                  fontSize: "2rem",
                  fontFamily: "Source Serif Pro",
                  fontWeight: "bold",
                  my: "1rem",
               }}
            >
               Popular Destination
            </Typography>
            <Tours />
         </Box>
         <Box
            sx={{
               mt: "2rem",
            }}
         >
            <Typography
               sx={{
                  textAlign: "center",
                  fontSize: "2rem",
                  fontFamily: "Source Serif Pro",
                  fontWeight: "bold",
                  my: "1rem",
               }}
            >
               Our Partners
            </Typography>
            <Partners />
         </Box>
      </>
   );
};

export default Dashboard;
